module.exports = __webpack_public_path__ + "components/flag/static/square/us-9cc8e5bf166cac22526c32957dce3f73.svg";